export default __webpack_public_path__ + "static/media/feature1.3f49c9b0.svg";